export enum LIVE_CHAT_TEST_IDS {
  WINDOW = 'live-chat-window',
  OPEN_BUTTON = 'live-chat-open-button',
  MINIMIZE_BUTTON = 'live-chat-minimize-button',
  CLOSE_BUTTON = 'live-chat-close-button',
  LOADING_INDICATOR = 'live-chat-loading-indicator',
  FEEDBACK = 'live-chat-feedback',
  FEEDBACK_TITLE = 'live-chat-feedback-title',
  FEEDBACK_INPUT = 'live-chat-feedback-input',
  FEEDBACK_SUBMIT = 'live-chat-feedback-submit',
  RATING_BUTTON = 'live-chat-rating-button',
  TEXT_INPUT = 'live-chat-text-input',
  SEND_BUTTON = 'live-chat-send-button',
  QUEUE_POSITION = 'live-chat-queue-position',
  UNREAD_COUNT = 'live-chat-unread-count',
  TITLE = 'live-chat-window-title',
  AGENT_TYPING = 'live-chat-agent-typing',
  SKIP_LINK = 'live-chat-skip-link',
  ATTACHMENT_STATUS = 'live-chat-attachment-status'
}
